var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-h5-regular color-gy-9"},_vm._l((_vm.row.roleName),function(item,index){return _c('Tag',{key:index,staticClass:"mr-4",staticStyle:{"display":"inline-block"},attrs:{"content":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }